// import logo from './logo.svg';
import './App.css';
import React, { useEffect, useState } from 'react'
import OneSignal from 'react-onesignal';
import Header from './components/Header';

import Sidebar from './components/Sidebar';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Inicio from './screens/Inicio';
import Perfil from './screens/Perfil';
import Aceptados from './screens/Events/Aceptados';
import Creados from './screens/Events/Creados';

// Importaciones para el modal
import { Button } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide } from '@mui/material';



import { Provider, connect } from 'react-redux';
import store from './store'
import RoutesList from './Routes/RoutesList';
import { LoadScriptNext } from '@react-google-maps/api';

// import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {


  useEffect(() => {
    // const OneSignalSetup = async () => {
    //   await OneSignal.init({
    //     appId: "e4d35e17-1fb3-48c5-862a-5febc684c4af", // Reemplaza con tu App ID de OneSignal
    //     safari_web_id: "web.onesignal.auto.5093406a-927f-4c57-a877-608b6718a7cc",
    //     allowLocalhostAsSecureOrigin: true, // Solo para pruebas locales
    //     notifyButton: {
    //       enable: true, // Habilita el botón de notificaciones flotante
    //     },
    //   });



    //   OneSignal.showSlidedownPrompt(); // Muestra el permiso para las notificaciones
    // };

    // OneSignalSetup();

    // Your web app's Firebase configuration
    // const firebaseConfig = {
    //   apiKey: "AIzaSyAv2gmZYl03K-EsNmKwOF0rNhO1YMrvj5Q",
    //   authDomain: "hisocialize-e0aee.firebaseapp.com",
    //   projectId: "hisocialize-e0aee",
    //   storageBucket: "hisocialize-e0aee.firebasestorage.app",
    //   messagingSenderId: "345684887027",
    //   appId: "1:345684887027:web:61ed0944ee4b116791be86"
    // };

    // Initialize Firebase
    // const app = initializeApp(firebaseConfig);
  }, []);

  return (
    <div className="App" style={app}>
      <Provider store={store}>
      <LoadScriptNext googleMapsApiKey="AIzaSyAv2gmZYl03K-EsNmKwOF0rNhO1YMrvj5Q"
      libraries={['places']} // Añade las librerías aquí
      >
        <RoutesList></RoutesList>
        </LoadScriptNext>
      </Provider>
    </div>
  );
}

const app = {
  minHeight: '100vh',
  backgroundColor: 'white',
  // backgroundColor: 'red',
  // paddingRight: '64px',
  // paddingLeft: '32px',
}

const content = {
  display: 'flex',
  width: '100%',
}

// const sidebar = {
//   width: '96px'
// }



export default App;

/*
PENDING TASKS:


quiero que hagas las siguientes modificaciones:
solo si el usuario escribe una ubicacion en el input, la ubicacion ingresada no se modificara hasta que el usuario la borre manualmente.
si desde el principio el usuario marca la ubicacion solo arrastrando el mapa, se mostrara la ubicacion señalada en el paper que esta debajo del input
el input no tendra ningun valor excepto si el usuario ingresa algo manualmente  
quiero que modifiques por completo la funcionalidad para detectar la modificacion de ubicacion manual de la automatica que ya esta creada














 - Corregir modelo responsive al abrir el menu lateral
 - Alargar imagen del menu principal, para que en notebooks no sobresalga
 - Investigar como mandar los tokens a los endpoints para que si o si un usuario logeado en el sistema pueda usarlos
 - Investigar cono codificar las contraseñas que llegan a la bd
 - FALTA COMPROBAR QUE FUNCIONE LA EDICION Y ELIMINACION DE EVENTOS CON LAS AUTORIZACIONES Y LOS ENCRIPTADOS
 - Configurar para que se envie el mail al correo especificado por el usuario
 - Corregir boton para enviar contraseña
 - Configurar correctamente el msg del mail
 - Configurar para poder cambiar la contraseña correctamente
 - Verificar que funcione para crear un evento simple
 - Verificar que tanto en la version web como movil se muestren los iconos del menu lateral correspondientes (si no estas registrado solo se deberia mostrar la casita)
 Quitar la opcion para cargar imagen en la pantalla de edicion de evento
 Cambiar el titulo de la pantalla de edicion de evento
 Ocultar el ID del usuario en la pantalla de perfil
 Ocultar de momento los filtros de busqueda del header
 Corregir el date picker en la pantalla de edicion de evento
 Corregir el time picker en la pantalla de edicion de evento
 Verificar la informacion que envian los endpoints para evitar que se envie informacion privada 
 Corregir funcionalidad de actualizacion de datos del usuario en pantalla perfil
 
 
 
 
 
 
 Corregir para que los eventos muestren el mismo nombre del usuario propietario
 Limpiar los datos de todos los console.log
HABILITAR OPCION PARA REGISTRARSE CON LA CUENTA DE GOOGLE
 
 Crear una pantalla de cargando
Cuando haya muchos eventos creados, se crearia un apartado donde aparecerian los eventos mas destacados a nivel nacional/mundial
Crear una pantalla de Error en caso de que el usuario quiera acceder a una pantalla a la que no tiene acceso

*/